import jMoment from 'moment-jalaali'
import { useEffect, useState } from 'react'
import { api } from '../../tools/request'
import { renderCurrency, renderCurrencyColumn } from './utils'
import { Space, Table, Typography, DatePicker } from '../../UI'

const { Title } = Typography

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_FROM_DATE = '2020-01-01'
const DEFAULT_TO_DATE = new Date().toISOString().split('T')[0]

const columns = [
  { key: 'effectiveDate', title: 'تاریخ', render: convertDate },
  {
    key: 'amount',
    title: renderCurrencyColumn('مبلغ'),
    render: renderCurrency
  },
  { key: 'description', title: 'توضیحات', render: (f) => f || '-' }
]

export default function WalletDetail() {
  const [data, setData] = useState({ items: [], totalCount: 0 })
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const [fromDate, setFromDate] = useState(DEFAULT_FROM_DATE)
  const [toDate, setToDate] = useState(DEFAULT_TO_DATE)

  useEffect(() => {
    setLoading(true)
    api('/charge-transaction/find-all', {
      method: 'POST',
      data: {
        fromDate,
        toDate,
        page: page - 1,
        size: pageSize
      }
    })
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false))
  }, [page, pageSize, fromDate, toDate])

  function handleDateChange(_, [from, to]) {
    if (from && to) {
      setFromDate(convertJalaliToGregorian(from))
      setToDate(convertJalaliToGregorian(to))
    } else {
      setFromDate(DEFAULT_FROM_DATE)
      setToDate(DEFAULT_TO_DATE)
    }
  }

  return (
    <div>
      <Space style={{ marginBottom: '1rem' }}>
        <Title level={2}>پرداختی ها</Title>
      </Space>
      <Space style={{ marginBottom: '1rem', display: 'block' }}>
        <DatePicker.RangePicker size='large' onChange={handleDateChange} />
      </Space>
      <Table
        data={data.items}
        columns={columns}
        loading={loading}
        rowKey={'trackingCode'}
        pagination={{
          total: data.totalCount,
          pageSize: pageSize,
          current: page,
          showSizeChanger: true,
          onChange: (e) => setPage(e),
          onShowSizeChange: (e, size) => setPageSize(size)
        }}
      />
    </div>
  )
}

function convertDate(date: string) {
  return jMoment(date, 'YYYY-M-D').locale('fa').format('jD jMMMM jYYYY')
}

function convertJalaliToGregorian(date: string) {
  return jMoment(date, 'jYYYY-jMM-jDD').locale('en').format('YYYY-MM-DD')
}
